<template>
  <v-container class="fill-height">
    <v-row justify="center" align="center">
      <v-col xs="12" md="10" lg="8">
        <v-card outlined class="pa-2">
          <v-alert outlined :color="!!GET_API_KEY ? 'success' : 'error'" :value="true">
            <span v-if="!GET_API_KEY">No API Key was found - contact support using the link below.</span>
            <span v-if="GET_API_KEY">API Connected</span>
          </v-alert>
          <v-alert outlined :color="!!GET_QUESTIONMARK_ID ? 'success' : 'error'" :value="true">
            <span v-if="!GET_QUESTIONMARK_ID">Could not link this account to a QuestionMark ID - contact support using the link below.</span>
            <span v-if="GET_QUESTIONMARK_ID">QuestionMark Connected</span>
          </v-alert>
          <v-subheader>
            This application provides the method for creating map-based questions within a QuestionMark
            assessment and for reviewing the subsequent answers by the candidates.
          </v-subheader>
          <v-subheader>
            To get started, we recommend reviewing our&nbsp;<router-link to="/knowledge-base">Knowledge Base
            <v-icon small>mdi-launch</v-icon>
          </router-link>
          </v-subheader>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {creating} from '../../store/modules/creating'
  import {marking} from '../../store/modules/marking'
  import {find} from '../../store/modules/find'
  import {reports} from '../../store/modules/reports'

  var storeModulesAdded = false;

  export default {
    name: "WelcomePage",

    computed: {
      ...mapGetters({
        GET_API_KEY: 'GET_API_KEY',
        GET_QUESTIONMARK_ID: 'GET_QUESTIONMARK_ID'
      })
    },

    data() {
      return {}
    }
  }
</script>

<style scoped>

</style>
